import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class Five9AccessibilityService {
	private observer: MutationObserver | null = null;

	init(): void {
		if (this.observer) return; // already running

		this.observer = new MutationObserver((mutations) => {
			mutations.forEach(() => {
				// Minimized (closed) state - the floating blue button
				const minimized = document.querySelector('.five9-frame-minimized');
				if (minimized && !minimized.hasAttribute('role')) {
					minimized.setAttribute('role', 'complementary');
					minimized.setAttribute('aria-label', 'Live chat support');
				}

				// The actual chat button inside it
				const chatButton = document.getElementById('five9-maximize-button');
				if (chatButton && !chatButton.hasAttribute('role')) {
					chatButton.setAttribute('role', 'button');
					chatButton.setAttribute('aria-label', 'Open chat');
					// Five9 already uses tabindex="0", so it's focusable
				}

				// Full/open chat window - treat as a dialog or region
				const fullFrame = document.querySelector('.five9-frame-full');
				if (fullFrame && !fullFrame.hasAttribute('role')) {
					fullFrame.setAttribute('role', 'dialog');
					fullFrame.setAttribute('aria-label', 'Chat window');
				}
			});
		});

		// Start observing the whole body (Five9 injects at root level)
		this.observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: false
		});

		console.log('✅ Five9AccessibilityService initialized');
	}

	destroy(): void {
		this.observer?.disconnect();
		this.observer = null;
	}
}
